var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",attrs:{"id":"social"}},[_c('div',{staticClass:"columns"},_vm._l((_vm.socials),function(social){return _c('div',{staticClass:"column is-2-fullhd is-3-desktop is-6-tablet is-12-mobile"},[_c('SocialCard',_vm._b({on:{"update":_vm.update}},'SocialCard',social,false))],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }